<template>
  <div class="cert-list">
    <h6 class="cert-list__title">
      My Certifications
    </h6>
    <div class="cert-list__wrapper">
      <CertificationsListItem
        v-for="certification in certifications"
        :key="certification.id"
        :certification="certification"
        :attempt="certAttempt(certification.attempt_id)"
      />
      <router-link :to="{ name: 'certifications' }" class="cert-list__get">
        <div class="cert-list__icon-wrapper">
          <PlusSymbolIcon class="cert-list__plus-icon" />
        </div>
        <p class="cert-list__get-certs">GET Certifications</p>
      </router-link>
    </div>
  </div>
</template>

<script>
import CertificationsListItem from '@/components/user-dashboard/certifications/CertificationsListItem.vue'
import PlusSymbolIcon from '@/assets/icons/plus_symbol_icon.svg'
import { mapGetters } from 'vuex'
import { allFinishedAttempts } from '@/helpers'

export default {
  name: 'CertificationsList',
  components: {
    CertificationsListItem,
    PlusSymbolIcon: { ...PlusSymbolIcon, name: 'PlusSymbolIcon' },
  },
  props: {
    certifications: {
      type: Array,
      required: true,
    },
  },
  data: () => {
    return {
      finishedAttempts: [],
    }
  },
  computed: {
    ...mapGetters({
      allVouchers: 'certifications/usersVouchers',
    }),
  },
  created() {
    this.finishedAttempts = allFinishedAttempts(this.allVouchers)
  },
  methods: {
    certAttempt(attempt_id) {
      return this.finishedAttempts.find(a => a.id === attempt_id)
    },
  },
}
</script>

<style lang="scss">
.cert-list {
  &__wrapper {
    @include tablet {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 20px;
    }
  }
  &__title {
    font-size: rem(24);
    line-height: 32px;
    color: var(--white);
    padding: 0;
    margin: 0 0 30px 0;
    width: 100%;
  }
  &__get {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    flex-grow: 1;
    color: var(--white);
    height: 436px;

    @include tablet {
      width: 460px;
    }
    border: 1px dashed var(--perfect-gray);
    &:hover {
      opacity: 0.8;
    }
  }
  &__get-certs {
    text-transform: uppercase;
    font-size: rem(12);
    font-weight: bold;
    line-height: 15px;
    color: var(--perfect-gray);
  }
}
</style>
